export function resolveGraphQLUrl() {
  return (
    process.env.GRAPHQL_URL_SELF_HOSTED ||
    process.env.NEXT_PUBLIC_GRAPHQL_URL ||
    process.env.VITE_GRAPHQL_URL
  )
}

/**
 * Operations that must NOT share the generic `/query` gateway endpoint.
 *
 * For security, a few sensitive auth/payment operations are served from dedicated paths
 * behind the gateway. The value is the path suffix appended to the resolved GraphQL base URL
 * (e.g. `.../query` -> `.../query/auth/register`). Keyed by GraphQL operation name.
 */
const OPERATION_ENDPOINTS: Record<string, string> = {
  register: '/auth/register',
  paymentsCreateSetupIntent: '/auth/create-trial',
}

// The generated documents are stable, module-level template strings, so caching the parsed
// operation name by document avoids re-running the regex on every request.
const operationNameCache = new Map<string, string | null>()

function getOperationName(query: string): string | null {
  const cached = operationNameCache.get(query)
  if (cached !== undefined) {
    return cached
  }

  const name = query.match(/\b(?:query|mutation|subscription)\s+([A-Za-z0-9_]+)/)?.[1] ?? null
  operationNameCache.set(query, name)
  return name
}

/**
 * Resolve the request URL for a given operation. Sensitive operations listed in
 * `OPERATION_ENDPOINTS` are routed to their dedicated endpoint; everything else uses `baseUrl`.
 */
export function resolveOperationUrl(query: string, baseUrl: string): string {
  const operationName = getOperationName(query)
  const suffix = operationName ? OPERATION_ENDPOINTS[operationName] : undefined
  return suffix ? `${baseUrl}${suffix}` : baseUrl
}

export function getCookie(cname: string) {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')

  // oxlint-disable-next-line typescript/prefer-for-of
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }

  return ''
}

export const TOKEN_LOCAL_STORAGE_KEY = 'cfToken'
